import Vue from "vue";
import Main from "./main.vue";
let MessageConstructor = Vue.extend(Main);

let instance;

const Message = function (options) {
  instance = new MessageConstructor({
    data: options,
  });
  instance.$mount();
  document.body.appendChild(instance.$el);
  instance.$nextTick(() => {
    let callback = (type) => {
      // type 1数据组装好 2关闭打印配置
      console.log(type);
    };
    if (typeof options.callback === "function") {
      callback = options.callback;
    }
    instance.htmlToCanvas(callback);
  });
  if (typeof options.callback === "function") {
    instance.callback = options.callback;
  }
  return instance;
};

export default Message;
